'use client';
import { atom, useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import type { ReactNode } from 'react';

import type { PremiseDataDocument } from '@dte/otw-azure-functions/src/common/interfaces/containers/premises/PremiseData';

import { useSetAtomWithType } from '../../../../../hooks/useSetAtomWithType';
import { AuthenticatedJsonContent } from '../../content/jsonGet/AuthenticatedJsonContent';
import { getPremiseMasterDataURL } from './status/getPremiseMasterDataURL';
import type { PropsWithPremiseId } from './usePremiseId';

export const premiseMasterDataAtom = atom<PremiseDataDocument | undefined>(undefined);

function PremiseMasterDataContent({ premiseId, children }: PropsWithPremiseId): ReactNode {
	const url = getPremiseMasterDataURL(premiseId);
	const setMasterDataAtom = useSetAtomWithType<PremiseDataDocument | undefined>(premiseMasterDataAtom);

	return (
		<>
			{children}
			<AuthenticatedJsonContent url={url} setData={setMasterDataAtom} />
		</>
	);
}

export function PremiseMasterDataProvider(props: PropsWithPremiseId): ReactNode {
	return (
		<ScopeProvider atoms={[premiseMasterDataAtom]}>
			<PremiseMasterDataContent {...props} />
		</ScopeProvider>
	);
}

export function usePremiseMasterData(): PremiseDataDocument | undefined {
	return useAtomValue(premiseMasterDataAtom);
}
